// maintain alphabetical order
export const enDashboard = {
  DashboardSnackbarErrorFindingMaxDates: 'Error finding max dates. Now loading without live data',
  DashboardSnackbarErrorRefreshingData: 'Error refreshing data. Data was last successfully updated at {{timestamp}}.',
  DashboardTooltipClickToPause: 'Click to pause.',
  DashboardTooltipClickToStart: 'Click to start',
  DashboardTooltipComparisonData: 'Show / Hide Comparison Data',
  DashboardTooltipDownloadCSV: 'Download chart data as CSV.',
  DashboardTooltipExcludeToday: 'This toggle is only available if Last 7 Days or Last 30 Days is selected as the date range',
  DashboardTooltipLastUpdatedTime: 'Last Updated: {{timestamp}}',
};
